// extracted by mini-css-extract-plugin
module.exports = {"onboardingInfo":"style_onboardingInfo__3CGZp","navButton":"style_navButton__ipW47","forward":"style_forward__1b_qb","back":"style_back__3olf9"};